import getCoordinatesFromPOIAddress from 'utils/addresses/methods/getCoordinatesFromPOIAddress';

const getCoordinatesFromPOIServiceResponse = (response) => {
  if (!response || !response.features) {
    return;
  }
  const addresses = response.features || [];

  return addresses.map(getCoordinatesFromPOIAddress);
};

export default getCoordinatesFromPOIServiceResponse;
